/* ============
 * NoData Component
 * ============
 *
 * todo: add documentation here!
 */

export default {
  mounted() {
    console.log('NoData component has been mounted!');
  },
};



// WEBPACK FOOTER //
// ./src/app/components/noData/noData.js